import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

const tileButtonStyle = (accent: string) => css`
	display: flex;
	align-items: center;
	gap: 0.875rem;
	min-width: 0;
	padding: 1rem;
	text-align: left;
	cursor: pointer;
	border-radius: 18px;
	background-color: ${theme.colors.surface};
	color: ${theme.colors.ink};
	border: 1.5px solid ${theme.colors.borderStrong};

	&:hover,
	&:focus-visible {
		border-color: ${accent};
	}
`;

const iconStyle = (accent: string) => css`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: none;
	width: 2.75rem;
	height: 2.75rem;
	border-radius: ${theme.radii.small};
	background-color: ${accent};
	color: ${theme.colors.surface};
`;

const textStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.1875rem;
	min-width: 0;
`;

const titleStyle = css`
	font-family: ${theme.fonts.display};
	font-size: 0.9375rem;
	font-weight: ${theme.fontWeights.semibold};
	line-height: 1.25;
`;

const subtitleStyle = css`
	font-family: ${theme.fonts.body};
	font-size: 0.75rem;
	line-height: 1.4;
	color: ${theme.colors.inkMuted};
`;

type Props = {
	readonly icon: React.ReactNode;
	/** Fill of the icon square and border color on hover. */
	readonly accent: string;
	readonly title: string;
	readonly subtitle: string;
	readonly onClick: () => void;
};

/** One entry point of « Rassembler »: an icon square, a title and a one-line explanation. */
const GatherTile: React.FC<Props> = ({ icon, accent, title, subtitle, onClick }) => {
	return (
		<button type="button" css={tileButtonStyle(accent)} onClick={onClick}>
			<span css={iconStyle(accent)}>{icon}</span>
			<span css={textStyle}>
				<span css={titleStyle}>{title}</span>
				<span css={subtitleStyle}>{subtitle}</span>
			</span>
		</button>
	);
};

export default GatherTile;
